import { resolveEndpoint } from '../endpointUtils';

export default {
	getLcvAccounts: {
		uri: '/ibapi/v2/banks/:bankId/accounts/default?page=:page&size=:size&search=:search&paymentType=:paymentType&searchAccountNumber=:accountNumber&searchSortCode=:sortCode',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve({ page = 1, size = 60, search, paymentType, accountNumber, sortCode }) {
			return resolveEndpoint(this.uri, { page, size, search, paymentType, accountNumber, sortCode });
		},
	},
	getAccounts: {
		uri: '/ibapi/v2/banks/:bankId/accounts/default',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve({ page, size, search }) {
			return resolveEndpoint(this.uri, { page, size, search });
		},
	},
	getFavouriteAccounts: {
		uri: '/ibapi/v2/banks/:bankId/accounts/default/favourites',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve({ bankId }) {
			return resolveEndpoint(this.uri, { bankId });
		},
	},
	setFavouriteAccounts: {
		uri: '/ibapi/v2/banks/:bankId/accounts/default/favourites',
		x_bpi_version: '0.8.0',
		method: 'PUT',
		resolve({ bankId }) {
			return resolveEndpoint(this.uri, { bankId });
		},
	},
	getAccountDetails: {
		uri: '/ibapi/v2/banks/:bankId/accounts/default/:accountId',
		x_bpi_version: '0.8.0',
		method: 'GET',
		resolve(accountId) {
			return resolveEndpoint(this.uri, { accountId });
		},
	},
};
